import Brand from 'helpers/brand'

import Api from 'services/api'
import BaseModel from 'models/BaseModel'

const defaultFeatureTour = {
  id: null,
  internalName: '',
  title: 'New Features',
  message: '',
  brands: Brand.allBrandsOfCurrentBusinessUnit(),
  roles: ['dealer', 'fsr', 'technician'],
  tiers: ['basic', 'premium'],
  published: false,
  publishedAt: null,
  expired: false,
  expiredAt: null,
  siteMessages: [],
  isUpdatedCards: false
}

class FeatureTour extends BaseModel {
  constructor (options = defaultFeatureTour) {
    super(options || defaultFeatureTour)
    Object.seal(this)
  }

  save (updatedFeatureTourAttributes, onSaveSuccessCallback, onSaveFailCallback, onValidationErrorCallback) {
    const errors = { ...this._validate(updatedFeatureTourAttributes) }

    if (_.isEmpty(errors)) {
      const apiMethodName = updatedFeatureTourAttributes.id ? 'update' : 'create'

      return Api.FeatureTours[apiMethodName]({ ...defaultFeatureTour, ...updatedFeatureTourAttributes })
        .then((response) => {
          onSaveSuccessCallback(response)
        })
        .catch(() => {
          onSaveFailCallback()
        })
    } else {
      onValidationErrorCallback(errors)
    }
  }

  delete (onDeleteSuccessCallback, onDeleteFailCallback) {
    return Api.FeatureTours.delete(this.id)
      .then(() => {
        onDeleteSuccessCallback()
      })
      .catch(() => {
        onDeleteFailCallback()
      })
  }

  _validate (attributes) {
    const errors = {}

    if (_.isEmpty(attributes.brands)) {
      errors.brands = 'At least one brand is required'
    }

    if (_.isEmpty(attributes.roles)) {
      errors.roles = 'At least one role is required'
    }

    if (_.isEmpty(attributes.tiers)) {
      errors.tiers = 'At least one tier is required'
    }

    if (!attributes.internalName) {
      errors.internalName = 'Internal name is required'
    }

    if (!attributes.title) {
      errors.title = 'Title is required'
    }

    if (!attributes.message) {
      errors.message = 'Message is required'
    }

    if (_.isEmpty(attributes.siteMessages)) {
      errors.siteMessages = 'At least one site message is required'
    }

    return errors
  }
}

export default FeatureTour
